import * as ErrorHandler from 'common/ErrorHandler';
import { Api, SecureApi } from 'common/http';

export async function getHomepage() {
  try {
    const { data } = await Api.get('/homepage-web');
    return data;
  } catch (err) {
    ErrorHandler.throwError(err, 'Error while getting homepage data', { err });
  }
}

export async function getPersonalizedHomepage() {
  try {
    const { data } = await SecureApi.get('/homepage-web');
    return data;
  } catch (err) {
    ErrorHandler.throwError(err, 'Error while getting personalized homepage data', { err });
  }
}

export async function getHomepagePreview(previewId) {
  try {
    const { data } = await Api.get(`/homepage/preview/${previewId}`);
    return data;
  } catch (err) {
    ErrorHandler.throwError(err, 'Error while getting homepage preview data', { err });
  }
}

export async function getPersonalizedHomepagePreview(previewId) {
  try {
    const { data } = await SecureApi.get(`/homepage/preview/${previewId}`);
    return data;
  } catch (err) {
    ErrorHandler.throwError(err, 'Error while getting personalized homepage preview data', { err });
  }
}
